<!-- 设备实时温度折线图 -->
<template>
  <div class="wet-chart">
    <div class="chart" ref="chart">
    </div>
    <div style="position: absolute;right: 3px;top:3px;">
      <el-date-picker v-model="dt" value-format="yyyy-MM-dd" type="date" :clearable="false" style="width: 150px" @change="query"></el-date-picker>
    </div>
  </div>
</template>

<script>

import BaseVue from "@/components/base/BaseVue";
import * as echarts from 'echarts';

export default {
  extends: BaseVue,
  components: {},

  props: {
    deviceCode : {
      required: true
    }
  },

  data() {
    return {
      chart: null,
      dt: new Date().format(),
      option: {
        title: {
          text: '实时湿度趋势图',
          x:'center'
        },
        grid:{
          top: 60
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return params[0].name+"：<br/>"+params[0].seriesName +"："+ params[0].value + "%<br/>"
                + params[1].seriesName +"："+ params[1].value + "%<br/>"
                + params[2].seriesName +"："+ (params[2].value == 1 ? "开":"关") + "<br/>"
                + params[3].seriesName +"："+ (params[3].value == 1 ? "开":"关");
          },
          axisPointer: {
            animation: false
          }
        },
        color: ['#0000FF','#1B98E0','#67C23A','#E6A23C'],
        legend: {
          top: 35
        },
        // dataZoom:[ {
        //   show: true,
        //   realtime: true,
        //   start: 70,
        //   end: 100,
        //   xAxisIndex: 0
        // },{
        //   type: 'inside',
        //   realtime: true,
        //   xAxisIndex: 0
        // }],
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          data:[]
        },
        yAxis: [{
          name: '湿度',
          type: 'value',
          max: 100,
          splitLine: {
            show: false
          }
        },{
          name: '工作状态',
          type: 'value',
          pisition: 'right',
          max: 1,
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: '室内湿度',
          type: 'line',
          smooth: true,
          showSymbol: false,
          data: []
        },{
          name: '室外湿度',
          type: 'line',
          smooth: true,
          showSymbol: false,
          data: []
        },{
          name: '新风工作',
          data: [],
          type: 'line',
          showSymbol: false,
          yAxisIndex: 1,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#67C23A'
            }, {
              offset: 1,
              color: '#fff'
            }])
          }
        },{
          name: '空调工作',
          data: [],
          type: 'line',
          showSymbol: false,
          yAxisIndex: 1,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#E6A23C'
            }, {
              offset: 1,
              color: '#fff'
            }])
          }
        }]
      }
    }
  },
  created() {
    this.$nextTick(()=>{
      this.chart = echarts.init(this.$refs["chart"]);
      this.chart.setOption(this.option);
    });
    this.query();
  },
  methods: {
    query() {
      this.loading = true;
      this.postForm("/device-status-his/getDayStatusList", {
        deviceCode: this.deviceCode,
        dt: this.dt
      }, true).then(dr => {
        this.clear();
        let data = dr.rows || [];
        data.forEach((status => {
          this.addStatus(status);
        }));
        this.refresh();
      }).finally(()=>{
        this.loading = false;
      });
    },
    //清空数据
    clear: function(){
      this.option.xAxis.data = [];
      //室内温度
      this.option.series[0].data = [];
      //室外温度
      this.option.series[1].data = [];
      //新风状态
      this.option.series[2].data = [];
      //空调状态
      this.option.series[3].data = [];
    },
    //添加一个时间点的状态
    addStatus: function(status){
      this.option.xAxis.data.push(status.receiveTime);
      //室内湿度
      this.option.series[0].data.push(status.inWet);
      //室外湿度
      this.option.series[1].data.push(status.outWet);
      //新风状态
      this.option.series[2].data.push(status.fanState == 1?1:0);
      //空调状态
      this.option.series[3].data.push(status.acState==1?1:0);
    },
    refresh() {
      this.chart.setOption(this.option);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../css/variables";
.wet-chart {
  padding: 10px;
  position: relative;
  border: 1px solid $color-border-primary;
  border-radius: 5px;
  margin-bottom: 20px;
  .chart {
    min-height: 400px;
  }
}
</style>
